import { useAuthenticatedApiClient } from '@guiker/react-framework'
import { AuthenticatedApiClient } from '@guiker/statistic-shared'

export const useAuthenticatedStatisticApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
